import React, { useContext } from 'react';
import { IWatchContext, WatchContext } from '../../../../watchState/watchContext';
import { UserRoles, IWatches } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import Text from 'components/Text/Text';
import DataController from 'components/DataController/DataController';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IWatches['items'][0];
	index: number;
}

export const Item: React.FC<IProps> = ({ data, index }) => {
	const { setIDForDeletion, setIDForFullInfo } = useContext<IWatchContext>(WatchContext);
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	const serialNumberRowClasses = classNames(style.serialNumber, style.row);
	const restaurantRowClasses = classNames(style.restaurant, style.row);
	const customerRowClasses = classNames(style.customer, style.row);
	const actionRowClasses = classNames(style.action, style.row);

	const handleClickInfo = () => {
		setIDForFullInfo(data.id);
	};

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	return (
		<div data-test={`Item${index}`}>
			<div className={style.container}>
				<Text className={serialNumberRowClasses} translationKey={data.serialNumber} withTooltip={true} />
				<Text className={restaurantRowClasses} translationKey={data.restaurantAddress} withTooltip={true} />
				<Text className={customerRowClasses} translationKey={data.customerName} withTooltip={true} />
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={hasAccess ? handleClickInfo : undefined}
						onClickDelete={hasAccess ? handleSetIdForDeletion : undefined}
						URLWithIDToEdit={hasAccess ? `/watches/edit?watchID=${data.id}` : undefined}
						size="smallBtn"
						isOpenInfo={false}
					/>
				</div>
			</div>
		</div>
	);
};
